import type { NoticeWithType } from "../../components/ViewNotices";
import { splitNoticesForFeed } from "../../utils/noticeFeedFilters";
import { nameMatches } from "./nameMatches";

/** How many Notices instant search lists. */
const NOTICE_RESULTS = 5;

/**
 * Notices whose title matches what's being typed, for instant search: the
 * ones on the Notices page's Sent and Scheduled tabs, newest first.
 */
export function searchNotices<N extends NoticeWithType>(text: string, notices: N[]): N[] {
  if (text.trim().length < 2) return [];
  const { publishedNotices, scheduledNotices } = splitNoticesForFeed(notices);

  return [...scheduledNotices, ...publishedNotices]
    .filter((notice) => nameMatches(notice.title, text))
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, NOTICE_RESULTS);
}
